"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getCommerceTemplate", {
  enumerable: true,
  get: function get() {
    return _getTemplate4["default"];
  }
});
Object.defineProperty(exports, "getMediaTemplate", {
  enumerable: true,
  get: function get() {
    return _getTemplate6["default"];
  }
});
Object.defineProperty(exports, "getProductTemplate", {
  enumerable: true,
  get: function get() {
    return _getTemplate3["default"];
  }
});
Object.defineProperty(exports, "getSearchTemplate", {
  enumerable: true,
  get: function get() {
    return _getTemplate5["default"];
  }
});
Object.defineProperty(exports, "getWebInteractionTemplate", {
  enumerable: true,
  get: function get() {
    return _getTemplate2["default"];
  }
});
Object.defineProperty(exports, "getWebPageDetailsTemplate", {
  enumerable: true,
  get: function get() {
    return _getTemplate["default"];
  }
});
var _getTemplate = _interopRequireDefault(require("./webPageDetails/getTemplate"));
var _getTemplate2 = _interopRequireDefault(require("./webInteraction/getTemplate"));
var _getTemplate3 = _interopRequireDefault(require("./product/getTemplate"));
var _getTemplate4 = _interopRequireDefault(require("./commerce/getTemplate"));
var _getTemplate5 = _interopRequireDefault(require("./search/getTemplate"));
var _getTemplate6 = _interopRequireDefault(require("./media/getTemplate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }